// Символы поддерживаемых фиат-валют. Общий справочник для переиспользования
// (адаптер useCoins, форматтеры и пр.). Держим синхронно со списком
// поддерживаемых валют (usd/rub/eur).
export const CURRENCY_SYMBOLS = {
  usd: "$",
  rub: "₽",
  eur: "€",
};

// Символ валюты с фолбэком на "$" для неизвестных/непереданных значений.
export const fiatSymbol = (fiat = "usd") =>
  CURRENCY_SYMBOLS[String(fiat).toLowerCase()] ?? "$";
